module.exports = __webpack_public_path__ + "img/MAC1100&1120&1130.0113975d.png";